import { type PublicIdea, PublicIdeaSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { ApiError, apiFetch } from '../../../lib/api-client';

export const ideaKey = (id: string) => ['idea', id] as const;

export const useIdea = (id: string) => {
  return useQuery<PublicIdea | null>({
    queryKey: ideaKey(id),
    queryFn: async () => {
      try {
        const raw = await apiFetch<unknown>(`/ideas/${id}`);
        return PublicIdeaSchema.parse(raw);
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          return null;
        }
        throw err;
      }
    },
  });
};
